import { render } from "./SpeechSwitch.vue?vue&type=template&id=096136ea"
import script from "./SpeechSwitch.vue?vue&type=script&lang=js"
export * from "./SpeechSwitch.vue?vue&type=script&lang=js"

import "./SpeechSwitch.vue?vue&type=style&index=0&id=096136ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__